export const scheduleFormDataName = {
  MONITORING_START_AT_DATETIME: 'monitoringStartAtDatetime',
  RECEIVING_DATA_DEADLINE_DATETIME: 'receivingDataDeadlineDatetime',
  PROCESSING_DATA_DEADLINE_DATETIME: 'processingDataDeadlineDatetime',
  NEW_DATA_DEADLINE_DATETIME: 'newDataDeadlineDatetime'
} as const

export const DEFAULT_DATE_PICKER_CLASSNAME = 'scheduleChangeForm__datePicker'
